import type { IntegrationCapability } from '@/lib/api/endpoints/integrations';

/**
 * Maps an onboarding connect chip's `provider.scopeKey` to the capability the
 * backend resolves into an explicit scope union (ADR 017 D4). The frontend names
 * a capability and never raw OAuth scopes — the backend (connectScopes) owns the
 * mapping, which is why the old hardcoded frontend scope maps (drifted from the
 * real grant — e.g. `gmail.readonly` where the grant is `gmail.modify`) are gone.
 *
 * Google + Microsoft (the scope-gated providers) narrow to the first-connect
 * base ∪ this capability (ADR 017 D4) — the capability names are provider-
 * agnostic; the backend resolves them to per-provider scopes. Every other
 * provider maps to `undefined` → the backend falls back to its preset unchanged.
 */
export function connectCapabilityFor(
  provider: string,
  scopeKey: string,
): IntegrationCapability | undefined {
  if (provider !== 'google' && provider !== 'microsoft') return undefined;
  switch (scopeKey) {
    case 'email':
      return 'mail';
    case 'calendar':
      return 'calendar';
    case 'drive':
      return 'drive';
    default:
      return undefined;
  }
}
